import { FC, PropsWithChildren } from 'react';
import { Popover, PopoverAnchor, PopoverContent } from '../ui/popover';

export const ActionBar: FC<PropsWithChildren<{ open: boolean }>> = ({
  open,
  children,
}) => {
  return (
    <Popover open={open}>
      <div className="fixed bottom-0 left-0 w-screen">
        <PopoverAnchor />
      </div>
      <PopoverContent className="bg-popover-foreground rounded-lg px-4 py-3 w-full">
        {children}
      </PopoverContent>
    </Popover>
  );
};
